import { ChangeDetectionStrategy, Component, computed, ElementRef, HostListener, inject, input, signal } from '@angular/core';
import { HeaderUtilitiesPanelComponent } from '@layout/header/components/header-utilities-panel/header-utilities-panel.component';
import { NotificationsFacade } from '@layout/notifications/facades/notifications.facade';

@Component({
  selector: 'itc-header-utilities-menu',
  templateUrl: 'header-utilities-menu.component.html',
  styleUrl: 'header-utilities-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderUtilitiesPanelComponent],
})
export class HeaderUtilitiesMenuComponent {
  private readonly elementRef = inject(ElementRef);
  private readonly notificationsFacade = inject(NotificationsFacade);

  readonly headerElement = input.required<HTMLElement>();
  readonly isMenuOpen = signal(false);
  readonly unreadNotificationsCount = computed(() => this.notificationsFacade.unreadNotificationsCount() ?? 0);

  @HostListener('document:click', ['$event'])
  onHeaderClick(event: MouseEvent): void {
    const targetComposedPath = event.composedPath();

    if (targetComposedPath.includes(this.headerElement()) && !targetComposedPath.includes(this.elementRef.nativeElement)) {
      this.isMenuOpen.set(false);
    }
  }

  @HostListener('window:popstate')
  onWindowNavigation(): void {
    this.isMenuOpen.set(false);
  }

  toggleMenu(): void {
    this.isMenuOpen.update(isOpen => !isOpen);
  }
}
